module.exports = __webpack_public_path__ + "288638af3de345189b2a71e2078d7d84.svg";